import React from "react";

import { IItemData } from "./common.typing";
import { getItemType } from "./utils";
import myPartnerImg from "./assets/imgs/my-partner.png";

import tagOrg from "./assets/imgs/tag-org.png";

export interface IPickerSelectProps {
    curListLabel: {
        pic: string;
        key: string | number;
        value: string | number;
        label: string;
        type?: 'org' | 'team' | 'user';
    }[];
    currentList: IItemData[]; // 添加 currentList prop
    setCurrentList: (list: IItemData[]) => void;
}

const PickerSelect: React.FC<IPickerSelectProps> = ({
    curListLabel,
    currentList,
    setCurrentList,
}) => {

    /**
     * 自定义选择区域渲染 - 按类型分组显示选中项
     * 按照部门、群聊、联系人的顺序展示，并为不同类型显示对应的图标
     *
     * @returns {JSX.Element} 渲染后的选择区域组件
     */
    const customSelectionRender = () => {
        // 按照类型分组：部门、群、人
        const groupedItems: { [key: string]: typeof curListLabel } = {
            org: [],
            team: [],
            user: []
        };

        // 对 curListLabel 进行分组
        curListLabel.forEach(item => {
            const itemType = item.type || getItemType(item.value);
            if (groupedItems[itemType]) {
                groupedItems[itemType].push(item);
            }
        });

        // 定义 curListLabel 项目的类型
        type LabelItem = typeof curListLabel[number];
        
        const typeConfigs = {
            org: {
                label: 'org',
                icon: () => tagOrg,
                iconClass: 'orgImg'
            },
            team: {
                label: 'team',
                icon: (item: LabelItem) => item.pic,
                iconClass: 'teamImg'
            },
            user: {
                label: 'user',
                icon: (item: LabelItem) => {
                    return item.key?.toString().includes('user') ? item.pic : myPartnerImg;
                },
                iconClass: 'userImg'
            }
        };
        const handleRemove = (item: LabelItem) => {
            // 移除该项的逻辑 - 从当前列表中移除该项
            const newList = curListLabel.filter(curItem => curItem.key !== item.key);
            // 转换回 IItemData 格式
            const newCurrentList = newList.map(v => {
                // 从原始数据中查找对应的项以获取 group_cate 和 pic
                const originalItem = currentList.find(c => c.id === v.key);
                if (!originalItem) {
                    // 如果找不到原始项，创建一个基础的 IItemData 对象
                    return {
                        id: v.key,
                        name: v.label,
                        group_cate: '',
                        pic: ''
                    };
                }
                return {
                    id: v.key,
                    name: v.label,
                    group_cate: originalItem.group_cate || '',
                    pic: originalItem.pic || ''
                };
            }).filter(item => item.id != null); // 过滤掉无效项
            setCurrentList(newCurrentList);
        };

        return (
            <div className="custom-selection-container">
                {Object.entries(groupedItems).map(([type, items]) => {
                    if (items.length === 0) return null;
                    const config = typeConfigs[type as keyof typeof typeConfigs] as {
                        iconClass?: string; label: string; icon: ((item: LabelItem) => string) };
                    return (
                        <div className="custom-selection-item">
                            {items.map((item, index) => (
                                    <span
                                        key={item.key}
                                        className={`ant-select-selection-item`}
                                    >
                                        {config.icon &&
                                            <span className="ant-select-selection-item-icon">
                                                <img
                                                    src={config.icon(item)}
                                                    alt={config.label}
                                                    className={config.iconClass}
                                                    onError={(e) => {
                                                        // 图片加载失败时隐藏图片元素
                                                        (e.target as HTMLImageElement).style.display = 'none';
                                                    }}
                                                />
                                            </span>
                                        }
                                        <span className="ant-select-selection-item-content">
                                            {item.label}
                                        </span>
                                        <span
                                            className="ant-select-selection-item-remove"
                                            onClick={() => handleRemove(item)}
                                        >
                                            ×
                                        </span>
                                    </span>
                                ))}
                        </div>
                    );
                })}
            </div>
        );
    };

    return (
        <div className="picker-select-container">
            {/* 自定义选择区域渲染 */}
            {curListLabel.length > 0 && (
                <div className="custom-selection-wrapper">
                    {customSelectionRender()}
                </div>
            )}
        </div>
    );
};

PickerSelect.defaultProps = {
    // searchData: [],
    curListLabel: [],
};

export default PickerSelect;
